import {connect} from 'react-redux'
import OpenSeaDragon from '../components/OpenSeaDragon.jsx'
import {
  showPage,
  closePage,
  endLoading
} from '../../../actions/Actions.js'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    image: state && state.bg && state.bg.image ? state.bg.image : null,
    overlays: state && state.bg && state.bg.overlays ? state.bg.overlays : null,
    isPageShowing: state && state.page && state.page.active !== undefined
      ? state.page.active
      : false
  }
}

// Map Redux actions to component props
function mapDispatchToProps (dispatch) {
  return {
    onShowPage: (id, open) => dispatch(showPage(id, open)),
    onClosePage: () => dispatch(closePage()),
    onEndLoading: () => dispatch(endLoading())
  }
}

// Connected Component
const OpenSeaDragonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OpenSeaDragon)

export default OpenSeaDragonContainer
